var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotSavings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FFEDD5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 20H19C18.7348 20 18.4804 19.8946 18.2929 19.7071C18.1054 19.5196 18 19.2652 18 19C18 18.7348 18.1054 18.4804 18.2929 18.2929C18.4804 18.1054 18.7348 18 19 18H36C36.2652 18 36.5196 17.8946 36.7071 17.7071C36.8946 17.5196 37 17.2652 37 17C37 16.7348 36.8946 16.4804 36.7071 16.2929C36.5196 16.1054 36.2652 16 36 16H19C18.2044 16 17.4413 16.3161 16.8787 16.8787C16.3161 17.4413 16 18.2044 16 19V35C16 35.7956 16.3161 36.5587 16.8787 37.1213C17.4413 37.6839 18.2044 38 19 38H39C39.5304 38 40.0391 37.7893 40.4142 37.4142C40.7893 37.0391 41 36.5304 41 36V22C41 21.4696 40.7893 20.9609 40.4142 20.5858C40.0391 20.2107 39.5304 20 39 20ZM34.5 30C34.2033 30 33.9133 29.912 33.6666 29.7472C33.42 29.5824 33.2277 29.3481 33.1142 29.074C33.0007 28.7999 32.9709 28.4983 33.0288 28.2074C33.0867 27.9164 33.2296 27.6491 33.4393 27.4393C33.6491 27.2296 33.9164 27.0867 34.2074 27.0288C34.4983 26.9709 34.7999 27.0006 35.074 27.1142C35.3481 27.2277 35.5824 27.42 35.7472 27.6666C35.912 27.9133 36 28.2033 36 28.5C36 28.8978 35.842 29.2794 35.5607 29.5607C35.2794 29.842 34.8978 30 34.5 30Z",
    fill: "#EA580C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotSavings);
export default __webpack_public_path__ + "static/media/tot-savings.f29fc47c6680e37d37e665fb129cc443.svg";
export { ForwardRef as ReactComponent };